import OneCase from '../screen/container/programs/program-matchmaking/complete-info';
import TwoCase from '../screen/container/programs/program-matchmaking/complete-info-process';
import ThreeCase from '../screen/container/programs/program-matchmaking/matching-panel';
import Directory from './../screen/container/programs/program-directory';
import Event from './../screen/container/programs/program-event';
import ProgramMatchmaking from '../screen/container/programs/program-matchmaking';
import Favorites from '../screen/container/programs/favorites/index';
import MatchingFavorite from '../screen/container/programs/favorites/matching-favorite';
import HomeFindProgram from '../screen/container/programs/home-find-program/index';
import { OEM_PROGRAM } from '../service/constant';

export const routesPrograms = [
  {
    component: Directory,
    exact: true,
    path: '/programs/home',
    guard: 'public',
  },
  {
    component: OneCase,
    exact: true,
    path: '/programs/one-case',
    guard: 'private',
    allowedRole: [OEM_PROGRAM],
  },
  {
    component: TwoCase,
    exact: true,
    path: '/programs/two-case',
    guard: 'private',
  },
  {
    component: ThreeCase,
    exact: true,
    path: '/programs/program-matching',
    guard: 'private',
  },
  {
    component: Event,
    exact: true,
    path: '/programs/event/:event_id',
    guard: 'private',
  },
  {
    component: ProgramMatchmaking,
    exact: true,
    path: '/program/matchmaking',
    guard: 'private',
  },
  {
    component: Favorites,
    exact: true,
    path: '/programs/favorites',
    gurad: 'private',
  },
  {
    component: MatchingFavorite,
    exact: true,
    path: '/programs/favorite',
    gurad: 'private',
  },
  {
    component: HomeFindProgram,
    exact: true,
    path: '/homeFindProgram',
    gurad: 'public',
  },
];
